import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import centralLogo from "../../Image/download.jpg";
import logoImage from "../../Image/knlogo.jpg";
import { useNavigate } from "react-router-dom";
import LoaderCon from "../../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../../Common/snackbar/components/snackbar";
import { useDispatch } from "react-redux";
import { close_snack_bar } from "../../../Common/snackbar/action";

const ProfilePage = ({ login, passwordChange, snackbar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => setShowPassword((prev) => !prev);

  const handleUpdate = () => {
    passwordChange(login.token, login.user_id, currentPassword, newPassword);
    setCurrentPassword("");
    setNewPassword("");
    navigate("/admin");
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        background: "#f3f6fa",
        paddingTop: "40px",
        display: "flex",
        justifyContent: "center",
        color: "#333",
      }}
    >
      <div
        style={{
          width: "90%",
          maxWidth: "950px",
          background: "#fff",
          borderRadius: "16px",
          padding: "25px",
          border: "1px solid #e6e8eb",
          boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
        }}
      >
        {/* Back Button */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={() => navigate("/admin")}
            style={{
              padding: "8px 18px",
              border: "1px solid #d0d0d0",
              background: "#fff",
              color: "#333",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "0.3s",
              fontSize: "14px",
            }}
            onMouseEnter={(e) =>
              (e.target.style.background = "#e7e9ed")
            }
            onMouseLeave={(e) =>
              (e.target.style.background = "#fff")
            }
          >
            Back
          </button>
        </div>

        {/* Logo */}
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <img
            src={centralLogo}
            alt="Logo"
            style={{
              width: "160px",
              borderRadius: "12px",
              boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
            }}
          />
        </div>

        <div
          style={{
            marginTop: "30px",
            display: "flex",
            flexWrap: "wrap",
            gap: "30px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Left Big Image */}
          <div
            style={{
              flex: "1 1 40%",
              textAlign: "center",
            }}
          >
            <img
              src={logoImage}
              alt="Profile"
              style={{
                width: "100%",
                maxWidth: "360px",
                borderRadius: "14px",
                boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
              }}
            />
          </div>

          {/* Right Side Form */}
          <div
            style={{
              flex: "1 1 50%",
              padding: "20px",
              background: "#ffffff",
              borderRadius: "14px",
              border: "1px solid #e6e8eb",
              boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
            }}
          >
            <h2
              style={{
                textAlign: "center",
                marginBottom: "20px",
                color: "#222",
                fontSize: "24px",
              }}
            >
              Profile Settings
            </h2>

            {/* Name */}
            <label
              style={{ color: "#555", fontSize: "14px", marginTop: "10px" }}
            >
              Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              value={login.name}
              readOnly
              style={{
                width: "100%",
                padding: "12px",
                marginTop: "5px",
                background: "#f8f9fb",
                border: "1px solid #ccc",
                borderRadius: "8px",
                fontSize: "15px",
                color: "#333",
              }}
            />

            {/* Email */}
            <label
              style={{ color: "#555", fontSize: "14px", marginTop: "20px" }}
            >
              Email <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              value={login.email}
              readOnly
              style={{
                width: "100%",
                padding: "12px",
                marginTop: "5px",
                background: "#f8f9fb",
                border: "1px solid #ccc",
                borderRadius: "8px",
                fontSize: "15px",
                color: "#333",
              }}
            />

            {/* Current Password */}
            <label
              style={{ color: "#555", fontSize: "14px", marginTop: "20px" }}
            >
              Current Password <span style={{ color: "red" }}>*</span>
            </label>
            <div style={{ position: "relative", marginTop: "5px" }}>
              <input
                type={showPassword ? "text" : "password"}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                style={{
                  width: "100%",
                  padding: "12px",
                  paddingRight: "40px",
                  background: "#f8f9fb",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  color: "#333",
                  fontSize: "15px",
                }}
              />
              <div
                onClick={togglePassword}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <EyeOff color="#777" /> : <Eye color="#777" />}
              </div>
            </div>

            {/* New Password */}
            <label
              style={{ color: "#555", fontSize: "14px", marginTop: "20px" }}
            >
              New Password <span style={{ color: "red" }}>*</span>
            </label>
            <div style={{ position: "relative", marginTop: "5px" }}>
              <input
                type={showPassword ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                style={{
                  width: "100%",
                  padding: "12px",
                  paddingRight: "40px",
                  background: "#f8f9fb",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  color: "#333",
                  fontSize: "15px",
                }}
              />
              <div
                onClick={togglePassword}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <EyeOff color="#777" /> : <Eye color="#777" />}
              </div>
            </div>

            {/* Update Button */}
            <div style={{ textAlign: "center" }}>
              <button
                onClick={handleUpdate}
                style={{
                  marginTop: "30px",
                  padding: "12px 26px",
                  background: "#1e90ff",
                  border: "none",
                  color: "#fff",
                  fontSize: "17px",
                  borderRadius: "10px",
                  cursor: "pointer",
                  transition: "0.3s",
                  boxShadow: "0 6px 18px rgba(30,144,255,0.3)",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.background = "#0f7be0")
                }
                onMouseLeave={(e) =>
                  (e.target.style.background = "#1e90ff")
                }
              >
                Update Profile
              </button>
            </div>
          </div>
        </div>
      </div>

      <LoaderCon />
      <Snackbar1
        open={snackbar.response_received}
        close_snack_bar={() => dispatch(close_snack_bar())}
        message={snackbar.message}
      />

    </div>
  );
};

export default ProfilePage;
